import { useEffect, useState } from "react";

import Button from "@mui/material/Button";
import { useFieldArray, useWatch } from "react-hook-form";
import { estimateShell, calculateShell } from "../../API`s/pv/sqliteApi";
import { toLegacy } from "../../fieldTranslation";
import {
  assignShellUIDs,
  resolveProjectTag,
} from "../../../../../../utils/pvUID";
import checkRequiredFields from "../../../../../../utils/checkRequiredFields";
import CustomAlert from "../../../../../../components/widgets/CustomAlert";
import { Stack, ListItemIcon, Box, Grid, Snackbar, Alert } from "@mui/material";
import InputTable from "./InputTable";
import ResultTable from "./ResultTable";
import EstimationTable from "./EstimationTable";
import BomTable from "../../../../AllEquipments/CommonFeatures/EstimationTab/BomTable";
import { buildShellBomDgv8, buildBomFromDgv8 } from "../bomHelpers";
import { usePVContext } from "../PVContext";
//The Main Function
const ShellTab = (props) => {
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Snackbar severity (success or error)
  const [openSnackbar, setOpenSnackbar] = useState(false); // Control Snackbar visibility

  const { reRender, project, equipId } = props;
  const [resultVisibility, setresultVisibility] = useState(false);
  const [estimationVisibility, setEstimationVisibility] = useState(false);
  const [bomVisibility, setBomVisibility] = useState(false);
  const [shellBomData, setShellBomData] = useState([]);
  const {
    control,
    setValue,
    getValues,
    currentRevision,
    revisionLoadVersion,
    wbsUid,
  } = usePVContext();
  const [isLoading, setIsLoading] = useState(false);
  const [showProgressBars, setShowProgressBars] = useState(false);

  const { fields: estimationFields } = useFieldArray({
    control,
    name: "DataGridView7",
  });

  // UID base: WBS UID from the header, falling back to the Design tab Tag No.
  const resolveTag = () =>
    resolveProjectTag({
      wbsUid,
      tagNo: getValues("tagNo"),
      legacyTag: getValues("TextBox48"),
    });

  const watchedShellRows = useWatch({ control, name: "DataGridView5" });
  const watchedTagNo = useWatch({ control, name: "tagNo" });

  // Keep Tag No. and shell UIDs ({TAG}-SH01 / {TAG}-HE01 ...) in sync with
  // the WBS UID and the row order. Heads and shells count separately.
  useEffect(() => {
    const tag = resolveProjectTag({
      wbsUid,
      tagNo: watchedTagNo,
      legacyTag: getValues("TextBox48"),
    });
    if (!tag) return;
    if (!watchedTagNo) {
      setValue("tagNo", tag, { shouldDirty: true });
    }
    const rows = watchedShellRows ?? [];
    if (!rows.length) return;
    const uids = assignShellUIDs(rows, tag);
    rows.forEach((row, i) => {
      if ((row?.UID || "") !== uids[i] && uids[i]) {
        setValue(`DataGridView5.${i}.UID`, uids[i], { shouldDirty: true });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchedShellRows, watchedTagNo, wbsUid]);
  const [openAlert, setOpenAlert] = useState(false);
  const [AlertContent, setAlertContent] = useState({
    severity: "",
    message: "",
  });

  const buildShellCalcInputs = () => {
    const raw = getValues();
    const data = { ...raw };

    if (!data.txt_DP_CSC && data.designInternalPressure) {
      data.txt_DP_CSC = data.designInternalPressure;
    }

    if (!data.txt_AS_CSC && data.shellStress) {
      data.txt_AS_CSC = data.shellStress;
    }

    if (!data.txt_JE_CSC && data.jointEffLong) {
      data.txt_JE_CSC = data.jointEffLong;
    }

    if (!data.txt_ID_CSC && data.vesselDiameter) {
      data.txt_ID_CSC = data.vesselDiameter;
    }

    if (!data.txt_PT_CSC) {
      const shellRows = data.DataGridView5;
      if (shellRows && shellRows.length && shellRows[0]["Provided Thk"]) {
        data.txt_PT_CSC = shellRows[0]["Provided Thk"];
      }
    }

    if (!data.txt_CA_CSC && data.corrosionAllowanceShell) {
      data.txt_CA_CSC = data.corrosionAllowanceShell;
    }

    if (!data.txt_DL_CSC && data.vesselLengthSS) {
      data.txt_DL_CSC = data.vesselLengthSS;
    }

    return data;
  };

  //calculation results
  const showResults = async () => {
    const data = buildShellCalcInputs();
    //const data = getValues();
    console.log(data);
    setEstimationVisibility(false);
    setBomVisibility(false);

    const result = checkRequiredFields(data);
    console.log(result);
    if (result[0] === false) {
      setAlertContent({
        message: "Following values are missingaas: " + result[1],
        severity: "error",
      });
      setOpenAlert(true);
    } else {
      setresultVisibility(true);
      setIsLoading(true);
      const res = await calculateShell(toLegacy(data));
      console.log("resss", res);

      setIsLoading(false);
      if (res.error) {
        console.log(res.error);
      } else {
        setValue("DataGridView6", res.data.DataGridView6);
      }
    }
  };

  const showEstimation = async () => {
    const data = getValues();
    setIsLoading(true);
    setShowProgressBars(true);
    setresultVisibility(false);
    setBomVisibility(false);
    setEstimationVisibility(true);

    // Assign UIDs ({TAG}-SH01 / {TAG}-HE01 ...) before sending to API
    const shellRows = data.DataGridView5 || [];
    const projectTag = resolveTag();
    const assignedUIDs = assignShellUIDs(shellRows, projectTag);
    shellRows.forEach((row, i) => {
      if (assignedUIDs[i] && row.UID !== assignedUIDs[i]) {
        setValue(`DataGridView5.${i}.UID`, assignedUIDs[i]);
        row.UID = assignedUIDs[i];
      }
    });

    const response = await estimateShell(toLegacy(data));
    setIsLoading(false);
    setShowProgressBars(false);
    if (response.error) {
      console.log(response.error);
    } else {
      setValue("DataGridView7", response.data.DataGridView7);
      // Preserve UIDs from original rows if the API response strips them
      const returnedRows = response.data.DataGridView5 || [];
      const mergedUIDs = assignShellUIDs(returnedRows, projectTag);
      const mergedRows = returnedRows.map((row, i) => ({
        ...row,
        UID: shellRows[i]?.UID || mergedUIDs[i] || "",
      }));
      setValue("DataGridView5", mergedRows);
    }
  };

  const handleShellBom = async () => {
    const data = getValues();
    /*
     * BOM follows the same secondary-table workflow
     * as Calculate and Estimate.
     */
    setresultVisibility(false);
    setEstimationVisibility(false);
    setBomVisibility(true);

    setIsLoading(true);

    const buildBom = (rows, estRows) =>
      buildBomFromDgv8(buildShellBomDgv8(rows, estRows));

    let shellRows = data.DataGridView5 || [];
    let shellEstRows = data.DataGridView7 || [];

    // Build BOM right away from whatever is in the form so the first
    // click is never empty (weights/hours fill in when estimation runs).
    setShellBomData(buildBom(shellRows, shellEstRows));

    // Auto-run estimation if it hasn't been done yet (no weights/hours)
    if (!shellEstRows.length || shellRows.every((r) => !r.Weight)) {
      const projectTag = resolveTag();
      const assignedUIDs = assignShellUIDs(shellRows, projectTag);
      shellRows.forEach((row, i) => {
        if (assignedUIDs[i] && row.UID !== assignedUIDs[i]) {
          setValue(`DataGridView5.${i}.UID`, assignedUIDs[i]);
          row.UID = assignedUIDs[i];
        }
      });

      const response = await estimateShell(toLegacy(data));
      if (!response.error) {
        if (response.data.DataGridView7)
          shellEstRows = response.data.DataGridView7;
        if (response.data.DataGridView5) {
          const returnedRows = response.data.DataGridView5;
          const mergedUIDs = assignShellUIDs(returnedRows, projectTag);
          const mergedRows = returnedRows.map((row, i) => ({
            ...row,
            UID: shellRows[i]?.UID || mergedUIDs[i] || "",
          }));
          shellRows = mergedRows;
          setValue("DataGridView5", mergedRows);
        }
        if (response.data.DataGridView7)
          setValue("DataGridView7", response.data.DataGridView7);
      }
    }

    // Always rebuild from the freshest form state so the first click
    // populates the table (no second press required).
    const freshAfter = getValues();
    const finalRows = freshAfter.DataGridView5 || shellRows;
    const finalEst = freshAfter.DataGridView7 || shellEstRows;
    console.log(
      "[BOM shell] final rows:",
      finalRows.length,
      "est:",
      finalEst.length,
    );
    setShellBomData(buildBom(finalRows, finalEst));

    setIsLoading(false);
  };

  // Guarantee the BOM is populated on the first press even if the click
  // handler ran before the form rows were flushed to state: rebuild the
  // table from live form values whenever the panel becomes visible.
  useEffect(() => {
    if (!bomVisibility) return;
    const data = getValues();
    const rows = data.DataGridView5 || [];
    const estRows = data.DataGridView7 || [];
    const bom = buildBomFromDgv8(buildShellBomDgv8(rows, estRows));
    console.log(
      "[BOM shell] effect rows:",
      bom.length,
      "of",
      rows.length,
      "source",
    );
    setShellBomData(bom);
  }, [bomVisibility]);

  const onUpdate3d = async () => {
    setSnackbarMessage("Update in progress");
    setSnackbarSeverity("info");
    setOpenSnackbar(true);

    const data = getValues()?.DataGridView5;
    const orientation = getValues("orientation");

    // ── Debug: log every field of every row ──
    console.group("Shell Update 3D — pre-flight check");
    console.log("Raw DataGridView5 rows:", data);
    console.log("Orientation:", orientation);

    const requiredFields = [
      "Component",
      "Diameter",
      "Material",
      "Can Length",
      "Long Seam",
      "Provided Thk",
    ];
    let emptyFound = false;

    data?.forEach((row, idx) => {
      console.log(`Row ${idx}:`, JSON.stringify(row));
      requiredFields.forEach((field) => {
        const val = row[field];
        if (
          val === "" ||
          val === null ||
          val === undefined ||
          String(val).trim() === ""
        ) {
          console.error(
            `  ❌ EMPTY FIELD — Row ${idx}, field "${field}" = "${val}"`,
          );
          emptyFound = true;
        }
      });
    });
    console.groupEnd();

    if (emptyFound) {
      setSnackbarMessage(
        "Please fill all Shell & Head fields (check console for details).",
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    const projectTag = resolveTag();
    const payloadUIDs = assignShellUIDs(data, projectTag);
    const SHELL_FIELDS = [
      "Component",
      "Diameter",
      "Material",
      "Can Length",
      "Long Seam",
      "Provided Thk",
      "Weight",
      "UID",
    ];

    const fomattedForFreeCadData = {
      data: {
        orientation: orientation,
        shellDesign: data?.map((row, i) => {
          const { id, ...rest } = row;
          const clean = {};
          SHELL_FIELDS.forEach((field) => {
            let val = rest[field];
            if (field === "UID") {
              val = val || payloadUIDs[i] || "";
            }
            if (val === null || val === undefined) {
              val = ["Component", "Material", "UID"].includes(field) ? "" : 0;
            }
            clean[field] = val;
          });
          return { ...clean, rowNo: i };
        }),
      },
    };
    console.log(
      "Payload sent to InvElectron:",
      JSON.stringify(fomattedForFreeCadData, null, 2),
    );

    let updateResponse = null;
    let updateError = null;

    try {
      updateResponse = await window.electron.pv.updateShell3d(
        fomattedForFreeCadData,
      );
      console.log("response :", updateResponse);
    } catch (error) {
      updateError = error;
      console.error("Shell 3D update failed:", error);
    }

    if (!updateError) {
      setSnackbarMessage(updateResponse?.message || "Shell 3D updated.");
      setSnackbarSeverity(updateResponse?.ok === false ? "error" : "success");
    } else {
      setSnackbarMessage("Shell 3D update failed.");
      setSnackbarSeverity("error");
    }
    setOpenSnackbar(true);
  };

  const hasSecondaryTable =
    resultVisibility || estimationVisibility || bomVisibility;

  return (
    <div
      style={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",

        boxSizing: "border-box",

        overflowX: "hidden",

        backgroundColor: "transparent",
      }}
    >
      <CustomAlert
        open={openAlert}
        setOpen={setOpenAlert}
        severity={AlertContent.severity}
        message={AlertContent.message}
      />

      <br />

      <Stack
        spacing={2}
        direction="row"
        sx={{
          flexWrap: "wrap",
          width: "100%",
          minWidth: 0,
        }}
      >
        <Button
          color={resultVisibility ? "secondary" : "primary"}
          onClick={() => showResults()}
          variant="contained"
        >
          Calculate
        </Button>

        <Button
          color={estimationVisibility ? "secondary" : "primary"}
          onClick={() => showEstimation()}
          variant="contained"
        >
          Estimate
        </Button>

        <Button
          color={bomVisibility ? "secondary" : "primary"}
          onClick={() => handleShellBom()}
          variant="contained"
          sx={{
            fontWeight: bomVisibility ? 700 : 600,
            ...(bomVisibility && {
              boxShadow: 2,
            }),
          }}
        >
          BOM
        </Button>
      </Stack>

      <br />
      <Box
        sx={{
          width: "100%",
          minWidth: 0,
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        <Grid
          container
          spacing={1}
          columns={12}
          alignItems="stretch"
          sx={{
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",
            m: 0,
            overflowX: "hidden",
          }}
        >
          {/* Main Shell Table */}
          <Grid
            item
            xs={12}
            md={hasSecondaryTable ? 7.8 : 12}
            sx={{
              minWidth: 0,
              maxWidth: "100%",
              overflow: "hidden",
            }}
          >
            <InputTable
              key={`shell-input-${currentRevision}-${revisionLoadVersion}`}
              reRender={reRender}
              isLoading={isLoading}
              projectId={project.id}
            />
          </Grid>

          {/* Calculate */}
          {resultVisibility && (
            <Grid
              item
              xs={12}
              md={4.2}
              sx={{
                minWidth: 0,
                maxWidth: "100%",
                overflow: "hidden",
              }}
            >
              <ResultTable isLoading={isLoading} />
            </Grid>
          )}

          {/* Estimate */}
          {estimationVisibility && (
            <Grid
              item
              xs={12}
              md={4.2}
              sx={{
                minWidth: 0,
                maxWidth: "100%",
                overflow: "hidden",
              }}
            >
              <EstimationTable
                key={`shell-estimation-${currentRevision}-${revisionLoadVersion}`}
                isLoading={isLoading}
                projectId={project.id}
                equipId={equipId}
              />
            </Grid>
          )}

          {/* BOM */}
          {bomVisibility && (
            <Grid
              item
              xs={12}
              md={4.2}
              sx={{
                minWidth: 0,
                maxWidth: "100%",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  minWidth: 0,
                  maxWidth: "100%",
                  overflowX: "hidden",

                  /*
                   * Force BOM to use exactly the same
                   * themed header colors as Shell/Nozzle.
                   */
                  "& .MuiTableHead-root .MuiTableCell-root, & thead th": {
                    backgroundColor:
                      "var(--pv-table-header-bg, hsla(250, 86%, 97%, 1)) !important",

                    color: "var(--pv-table-header-text, inherit) !important",

                    borderRight:
                      "1px solid var(--pv-table-border, rgba(170, 180, 198, 0.6)) !important",

                    borderBottom:
                      "1px solid var(--pv-table-border, rgba(170, 180, 198, 0.6)) !important",
                  },
                }}
              >
                <BomTable data={shellBomData} />
              </Box>
            </Grid>
          )}
        </Grid>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
            variant="filled"
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default ShellTab;
